// ======================================================================
// File Name       : LearningHistoryCSVDownloadContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Button } from 'react-bootstrap';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import moment from 'moment';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM, DORMANT_STATE, DEFAULT_DATE_FORMAT_SERVER } from '../../../constants';
import { CONTENT_TYPE_NAME, SELECTED_RANGE, TARGET_CONTENT } from '../../../constants/CSVDownloadConstant';
import { CONTENT_TYPE } from '../../../constants/ContentConstant';
import { USER_TYPE } from '../../../constants/UserConstants';
import { searchUser, getAttributeList } from '../../../actions/UserAction';
import { SERVICE_USER_TYPE } from '../../../constants/ServiceConstant';
import { HIDE_MESSAGE } from '../../../constants/actionTypes/message';
import * as MessageTemplate from '../../../constants/MessageTemplate';
import * as GroupAction from '../../../actions/GroupAction';
import * as ModalAction from '../../../actions/ModalAction';
import * as ModalIds from '../../../constants/ModalIds';
import * as csvDownloadActionCreators from '../../../actions/actionCreators/csvDownload';
import * as csvDownloadActions from '../../../actions/csvDownloadAction';
import ModalConductor from '../../../components/modal/ModalConductor';
import Header from '../../../components/Header';
import LearningHistoryCSVForm from '../../../components/userHistory/csv/LearningHistoryCSVForm';
import SelectGroupDlg from '../../../components/group/SelectUserGroupDialog';
import SelectContentTypeDialog from '../../../components/userHistory/csv/SelectContentTypeDialog';
import SelectContentLinkCourseDialog from '../../../components/userHistory/csv/SelectContentLinkCourseDialog';
import DialogConfirm from '../../../components/DialogConfirm';
import CustomLink from '../../../components/button/CustomLink';
import { USER_HISTORY_STUDENT_LIST } from '../../../constants/PathConstants';

class LearningHistoryCSVContainer extends Component {
  constructor() {
    super();
    this.state = {
      contentType: [],
      showSelectGroup: false,
      isShowSelectContentTypeDialog: false,
      showExportModal: false,
      isShowTargetUserError: false,
      isShowTargetContentError: false,
      errorUserLabel: '',
    };
    this.csvDownloadHandler = this.csvDownloadHandler.bind(this);
    this.changeTargetContentHandler = this.changeTargetContentHandler.bind(this);
    this.changeSelectedRangeHandler = this.changeSelectedRangeHandler.bind(this);
    this.showSelectGroupDialog = this.showSelectGroupDialog.bind(this);
    this.showSelectContentTypeDialog = this.showSelectContentTypeDialog.bind(this);
    this.showSelectContentDialog = this.showSelectContentDialog.bind(this);
    this.showSelectCourseDialog = this.showSelectCourseDialog.bind(this);
    this.cancelSelectContentTypeDialog = this.cancelSelectContentTypeDialog.bind(this);
    this.showSelectTargetUsersDialog = this.showSelectTargetUsersDialog.bind(this);
    this.okSelectContentTypeDialog = this.okSelectContentTypeDialog.bind(this);

    this.openSelectedRangeModal = this.openSelectedRangeModal.bind(this);
    this.openTargetContentModal = this.openTargetContentModal.bind(this);

    this.openExportDialog = this.openExportDialog.bind(this);
    this.onDialogExportCancel = this.onDialogExportCancel.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(GroupAction.fetchGroupStructure());
  }

  componentWillUnmount() {
    this.props.dispatch(csvDownloadActions.resetDataForCSVDownload());
  }

  /**
   * Handle event when CSV出力 button is clicked
   */
  csvDownloadHandler() {
    const {
      formValues,
      targetUserList,
      targetCourseList,
      targetContentList,
    } = this.props;
    const {
      includingDormantUsers,
      selectedTargetGroupIds,
      document,
      drill,
      link,
      video,
      createdDateFrom,
      createdDateTo,
    } = formValues;
    const param = {};
    param.dormantState = !!includingDormantUsers;
    selectedTargetGroupIds && (param.groupList = selectedTargetGroupIds);
    targetUserList && (param.userList = Object.keys(targetUserList));
    targetCourseList && (param.courseList = Object.keys(targetCourseList));
    targetContentList && (param.itemList = Object.keys(targetContentList));
    param.contentTypeList = [];
    if (video) {
      param.contentTypeList.push(CONTENT_TYPE.VIDEO);
    }
    if (drill) {
      param.contentTypeList.push(CONTENT_TYPE.DRILL);
    }
    if (document) {
      param.contentTypeList.push(CONTENT_TYPE.DOCUMENT);
    }
    if (link) {
      param.contentTypeList.push(CONTENT_TYPE.LINK);
    }
    createdDateFrom && (param.learningStartTimeFrom = moment(createdDateFrom)
      .startOf('day').format(DEFAULT_DATE_FORMAT_SERVER));
    createdDateTo && (param.learningStartTimeTo = moment(createdDateTo)
      .endOf('day').format(DEFAULT_DATE_FORMAT_SERVER));

    this.props.dispatch(csvDownloadActions.postGetHistoryList(param));
    this.setState({ showExportModal: false });
  }

  /**
   * Handle event when 全コンテンツ radio button is clicked
   */
  changeTargetContentHandler(event, newValue, previousValue) {
    // Reset data
    this.props.change('video', false);
    this.props.change('drill', false);
    this.props.change('document', false);
    this.props.change('link', false);
    this.props.change('selectedCourseBox', []);
    this.props.dispatch(csvDownloadActionCreators.resetSelectedCourseBoxList());
    this.setState({ contentType: [], isShowTargetContentError: false });
  }

  /**
   * Handle event when 全体 radio button is clicked
   */
  changeSelectedRangeHandler(event, newValue, previousValue) {
    // Reset data
    this.props.change('selectedTargetGroupIds', []);
    this.props.change('includingDormantUsers', false);
    this.setState({ isShowTargetUserError: false });
    this.props.dispatch(csvDownloadActionCreators.resetSelectedGroupList());
  }

  /**
   * Show Select Group Dialog
   */
  showSelectGroupDialog() {
    const isLearningHistoryCSV = true;
    this.props.dispatch(csvDownloadActionCreators.changeOpenSelectGroupFlag(true));
    this.props.dispatch(csvDownloadActionCreators.changeShowGroupFlag(false, isLearningHistoryCSV));
    this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_GROUP_MODAL));
  }

  /**
   * Show Select Content Type Dialog
   */
  showSelectContentTypeDialog() {
    this.setState({ isShowSelectContentTypeDialog: true });
  }

  /**
   * Handle event when click on キャンセル of select content type dialog
   */
  cancelSelectContentTypeDialog() {
    const { contentType } = this.state;
    const { formValues } = this.props;
    if (formValues.video && contentType.indexOf(CONTENT_TYPE_NAME.VIDEO) === -1) {
      this.props.change('video', false);
    }
    if (formValues.drill && contentType.indexOf(CONTENT_TYPE_NAME.DRILL) === -1) {
      this.props.change('drill', false);
    }
    if (formValues.document && contentType.indexOf(CONTENT_TYPE_NAME.DOCUMENT) === -1) {
      this.props.change('document', false);
    }
    if (formValues.link && contentType.indexOf(CONTENT_TYPE_NAME.LINK) === -1) {
      this.props.change('link', false);
    }

    if (!formValues.video && contentType.indexOf(CONTENT_TYPE_NAME.VIDEO) > -1) {
      this.props.change('video', true);
    }
    if (!formValues.drill && contentType.indexOf(CONTENT_TYPE_NAME.DRILL) > -1) {
      this.props.change('drill', true);
    }
    if (!formValues.document && contentType.indexOf(CONTENT_TYPE_NAME.DOCUMENT) > -1) {
      this.props.change('document', true);
    }
    if (!formValues.link && contentType.indexOf(CONTENT_TYPE_NAME.LINK) > -1) {
      this.props.change('link', true);
    }
    this.setState({ isShowSelectContentTypeDialog: false });
  }

  /**
   * Show Select Service Users Dialog
   */
  showSelectTargetUsersDialog() {
    this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_SERVICE_USER_DIALOG));
  }

  /**
   * Show Select Course Dialog
   */
  showSelectCourseDialog() {
    this.props.dispatch(csvDownloadActionCreators.changeSelectedFlag(false));
    this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_COURSE_DIALOG));
  }

  /**
   * Show Select Content Dialog
   */
  showSelectContentDialog() {
    this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_TARGET_CONTENT_DIALOG));
  }

  /**
   * Handle event when click on OK of select content type dialog
   */
  okSelectContentTypeDialog() {
    const { formValues } = this.props;
    const contentType = [];
    if (formValues.video) {
      contentType.push(CONTENT_TYPE_NAME.VIDEO);
    }
    if (formValues.drill) {
      contentType.push(CONTENT_TYPE_NAME.DRILL);
    }
    if (formValues.document) {
      contentType.push(CONTENT_TYPE_NAME.DOCUMENT);
    }
    if (formValues.link) {
      contentType.push(CONTENT_TYPE_NAME.LINK);
    }
    this.setState({ isShowSelectContentTypeDialog: false, contentType: [...contentType] });
  }

  /**
   * Handle event when click on 選択 button of SELECTED_RANGE
   */
  openSelectedRangeModal() {
    const { formValues } = this.props;
    const { selectedRange } = formValues;
    if (selectedRange === SELECTED_RANGE.GROUP) {
      this.showSelectGroupDialog();
    } else if (selectedRange === SELECTED_RANGE.USER) {
      this.showSelectTargetUsersDialog();
    }
  }

  /**
   * Handle event when click on 選択 button of TARGET_CONTENT
   */
  openTargetContentModal() {
    const { formValues } = this.props;
    const { targetContent } = formValues;
    if (targetContent === TARGET_CONTENT.COURSE) {
      this.showSelectCourseDialog();
    } else if (targetContent === TARGET_CONTENT.CONTENT_TYPE) {
      this.showSelectContentTypeDialog();
    } else if (targetContent === TARGET_CONTENT.CONTENT_SPECIFICATION) {
      this.showSelectContentDialog();
    }
  }

  /**
   * Handle open export dialog
   */
  openExportDialog(mdContent, mdSize) {
    const {
      formValues,
      targetUserList,
      targetCourseList,
      targetContentList,
    } = this.props;
    const {
      includingDormantUsers,
      selectedTargetGroupIds,
      document,
      drill,
      link,
      video,
      createdDateFrom,
      createdDateTo,
      selectedRange,
      targetContent,
    } = formValues;
    let checkTargetUser = true;
    let checkTargetContent = true;
    this.content = mdContent;
    this.mdSize = mdSize;

    const contentTypeLists = [];
    if (video) {
      contentTypeLists.push(CONTENT_TYPE.VIDEO);
    }
    if (drill) {
      contentTypeLists.push(CONTENT_TYPE.DRILL);
    }
    if (document) {
      contentTypeLists.push(CONTENT_TYPE.DOCUMENT);
    }
    if (link) {
      contentTypeLists.push(CONTENT_TYPE.LINK);
    }

    if (selectedRange !== SELECTED_RANGE.ALL || targetContent !== TARGET_CONTENT.ALL) {
      if (selectedRange !== SELECTED_RANGE.ALL) {
        if (!(selectedTargetGroupIds && selectedTargetGroupIds.length) &&
          !(Object.keys(targetUserList) && Object.keys(targetUserList).length)) {
          let errorLabel = '';
          selectedRange === SELECTED_RANGE.GROUP ? errorLabel = 'ユーザーグループ'
          : errorLabel = 'ユーザー';
          this.setState({ isShowTargetUserError: true, errorUserLabel: errorLabel, showExportModal: false });
          this.props.dispatch({ type: HIDE_MESSAGE });
          checkTargetUser = false;
        } else {
          checkTargetUser = true;
          this.setState({ isShowTargetUserError: false, errorUserLabel: '' });
        }
      }

      if (targetContent !== TARGET_CONTENT.ALL) {
        if (!(Object.keys(targetCourseList) && Object.keys(targetCourseList).length) &&
        !(Object.keys(targetContentList) && Object.keys(targetContentList).length) &&
        !(contentTypeLists && contentTypeLists.length)) {
          let errorLabel = '';
          switch (targetContent) {
            case TARGET_CONTENT.COURSE:
              errorLabel = 'コース';
              break;
            case TARGET_CONTENT.CONTENT_SPECIFICATION:
              errorLabel = 'コンテンツ';
              break;
            case TARGET_CONTENT.CONTENT_TYPE:
              errorLabel = 'コンテンツ種別';
              break;
            default:
          }
          this.setState({ isShowTargetContentError: true, errorContentLabel: errorLabel, showExportModal: false });
          this.props.dispatch({ type: HIDE_MESSAGE });
          checkTargetContent = false;
        } else {
          checkTargetContent = true;
          this.setState({ isShowTargetContentError: false, errorContentLabel: '' });
        }
      }
    }

    if (checkTargetContent && checkTargetUser) {
      this.setState({ showExportModal: true });
    }
  }

  /**
   * Handle Cancel button on export dialog
   */
  onDialogExportCancel() {
    this.setState({ showExportModal: false });
  }
  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { formValues, learningHistoryCSVDownload } = this.props;
    const { authedUser: { dormantUserDataAcquisitionPermissionFlag } } = this.props;

    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          text="戻る"
          icon="bi bi-chevron-left"
          onClick={this.goBack}
        />
        <Header name="学習履歴情報のダウンロード" />
        <LearningHistoryCSVForm
          {...formValues}
          isProgressStatusCSVDownloadContainer={false}
          isShowTargetUserError={this.state.isShowTargetUserError}
          isShowTargetContentError={this.state.isShowTargetContentError}
          errorContentLabel={this.state.errorContentLabel}
          errorUserLabel={this.state.errorUserLabel}
          isSelected={this.props.isSelected}
          isShowGroupNumber={this.props.isShowGroupNumber}
          contentType={this.state.contentType}
          csvDownloadHandler={this.csvDownloadHandler}
          changeTargetContentHandler={this.changeTargetContentHandler}
          changeSelectedRangeHandler={this.changeSelectedRangeHandler}
          showSelectGroupDialog={this.showSelectGroupDialog}
          showSelectTargetUsersDialog={this.showSelectTargetUsersDialog}
          showSelectCourseDialog={this.showSelectCourseDialog}
          showSelectContentTypeDialog={this.showSelectContentTypeDialog}
          showSelectContentDialog={this.showSelectContentDialog}
          openSelectedRangeModal={this.openSelectedRangeModal}
          openTargetContentModal={this.openTargetContentModal}
          openExportDialog={this.openExportDialog.bind(this, MessageTemplate.BULK_EXPORT_USER_HISTORY, null)}
          dormantUserDataAcquisitionPermissionFlag={dormantUserDataAcquisitionPermissionFlag}
        />
        <SelectContentTypeDialog
          showModal={this.state.isShowSelectContentTypeDialog}
          onCancel={this.cancelSelectContentTypeDialog}
          onOK={this.okSelectContentTypeDialog}
        />
        <ModalConductor />
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onDialogExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.csvDownloadHandler}
        />
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const {
    learningHistoryCSVDownload,
    isSelected,
    isShowGroupNumber,
    targetCourseList,
    targetUserList,
    targetContentList,
  } = state.csvDownload;
  const { content } = state;
  const { authedUser } = state.authed;
  const formValues = getFormValues('learningHistoryCSV')(state);

  return {
    ...{ learningHistoryCSVDownload },
    formValues,
    initialValues: learningHistoryCSVDownload,
    isSelected,
    isShowGroupNumber,
    targetCourseList,
    targetUserList,
    targetContentList,
    content,
    authedUser,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'learningHistoryCSV', // a unique identifier for this form
  touchOnChange: true,
})(LearningHistoryCSVContainer));
